import { createSlice } from "@reduxjs/toolkit";
import { blogDetailApi } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const blogDetailSlice = createSlice({
  name: "blogDetail",
  initialState: data,
  reducers: {
    blogDetailSlice(state) {
      state.isLoading = false;
    },
    blogDetailSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    blogDetailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    blogDetailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const blogDetailHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(blogDetailAction.blogDetailSlice());
    const response: any = await blogDetailApi(id);
    dispatch(blogDetailAction.blogDetailSliceSuccess(response));
  } catch (e: any) {
    dispatch(blogDetailAction.blogDetailSliceFailure(e?.response?.data?.message));
    dispatch(blogDetailAction.blogDetailSliceReset());
  }
};
export default blogDetailSlice.reducer;
export const blogDetailAction = blogDetailSlice.actions;
